export default "__VITE_ASSET__DUDGdo3m__"